import { useState } from 'react'
import { Box } from '@mui/material'
import { ChevronDown20Regular, ChevronRight20Regular } from '@/components/Icon'
import styles from './HomeNavPane.module.scss'

/** A rail section: a foldable header over its rows. Shared by both panes. */
export default function HomeNavSectionToggle({ title, defaultExpanded = true, children, className, actions }) {
  const [expanded, setExpanded] = useState(defaultExpanded)
  const Chevron = expanded ? ChevronDown20Regular : ChevronRight20Regular
  const toggle = (
    <button
      type="button"
      className={styles.sectionToggle}
      aria-expanded={expanded}
      onClick={() => setExpanded((value) => !value)}
    >
      <span className={styles.sectionLabelText}>{title}</span>
      <Chevron className={styles.sectionChevron} aria-hidden />
    </button>
  )

  return (
    <Box className={[styles.group, className].filter(Boolean).join(' ')}>
      {actions ? (
        <div className={styles.sectionHeader}>
          {toggle}
          {actions}
        </div>
      ) : toggle}
      {expanded ? children : null}
    </Box>
  )
}
